import React from "react";

const BlogCard = ({ title, pubDate, link }) => {
  return (
    <div className="p-6 max-w-sm w-full md:w-3/4 text-center m-4 rounded-lg border shadow-lg bg-blue-900 border-transparent hover:-translate-y-4 transition-all duration-700 cursor-pointer">
      <h5 className="mb-2 md:text-2xl text-xl font-bold tracking-normal text-white">
        {title}
      </h5>
      <p className="mb-3 font-normal text-gray-400">
        Published on: {pubDate.split(" ")[0]}
      </p>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white rounded-lg focus:ring-4 focus:outline-none bg-[#090E34] focus:ring-[#090E34]"
      >
        Read more
        <svg
          className="ml-2 -mr-1 w-4 h-4"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      </a>
    </div>
  );
};

export default BlogCard;
